/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownPassportType } from '../models/db_DropdownPassportType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PassportTypes {
    /**
     * Get a list of passport types
     * @returns db_DropdownPassportType OK
     * @throws ApiError
     */
    public static listPassportTypes(): CancelablePromise<Array<db_DropdownPassportType>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/passport-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
